export default "<div class=\"card card-border-radius\">\n  <div #container1></div>\n</div>\n";